import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "@/lib/api";
import { Label, FreePill, StarRating, Sponsored } from "@/components/Badges";
import InventoryMeter from "@/components/InventoryMeter";

export default function ProductCard({ p, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: (index % 4) * 0.05 }}
      className="group"
      data-testid={`product-card-${p.slug}`}
    >
      <Link to={`/friib/${p.slug}`} className="block bg-white rounded-2xl overflow-hidden friib-shadow hover:friib-shadow-hover transition-all duration-300 hover:-translate-y-1 border border-stone-100">
        <div className="relative aspect-square overflow-hidden bg-stone-50">
          <img src={p.images?.[0]} alt={p.name} loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
          <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
            {(p.labels || []).slice(0, 2).map((l) => <Label key={l}>{l}</Label>)}
          </div>
          {p.sponsored && <div className="absolute top-3 right-3"><Sponsored /></div>}
        </div>
        <div className="p-4">
          <div className="flex items-center justify-between mb-1">
            <span className="text-xs font-bold uppercase tracking-wider" style={{ color: p.brand_color || "var(--friib)" }}>{p.brand_name}</span>
            <StarRating rating={p.rating} count={p.review_count} size={12} />
          </div>
          <h3 className="font-display font-bold text-lg text-stone-900 leading-snug mb-2 line-clamp-1">{p.name}</h3>
          <div className="flex items-center gap-2 mb-3">
            <FreePill />
            <span className="text-sm text-stone-400 line-through">{money(p.retail_value)} value</span>
          </div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm font-bold" style={{ color: "var(--friib)" }}>Just {money(p.shipping)} shipping</span>
          </div>
          <InventoryMeter claimed={p.inventory_claimed} total={p.inventory_total} remaining={p.inventory_remaining} />
          <div className="mt-3 w-full text-center py-2.5 rounded-full font-bold text-white text-sm transition-colors"
            style={{ background: "var(--ink)" }}>Claim Friib</div>
        </div>
      </Link>
    </motion.div>
  );
}
